import TeacherGradeData from './TeacherGradeData';

export default TeacherGradeData;
